import React, { useEffect, useState } from "react";
import { apiUrl } from "../helpers/api";
import { getToken } from "../helpers/authHelper";

const useAuthenticatedMedia = (source) => {
  const [result, setResult] = useState({ url: "", error: "" });
  useEffect(() => {
    if (!source) {
      setResult({ url: "", error: "" });
      return undefined;
    }
    if (!source.startsWith("/api/media/") && !source.startsWith("/api/brand-settings/product-media/")) {
      setResult({ url: apiUrl(source), error: "" });
      return undefined;
    }
    const abortController = new AbortController();
    let objectUrl = "";
    setResult({ url: "", error: "" });
    fetch(apiUrl(source), {
      headers: { Authorization: `Bearer ${getToken()}` },
      signal: abortController.signal
    }).then((response) => {
      if (!response.ok) throw new Error("Media preview unavailable.");
      return response.blob();
    }).then((blob) => {
      objectUrl = URL.createObjectURL(blob);
      setResult({ url: objectUrl, error: "" });
    }).catch((error) => {
      if (error.name !== "AbortError") setResult({ url: "", error: error.message });
    });
    return () => {
      abortController.abort();
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [source]);
  return result;
};

const AuthenticatedMedia = ({ src, alt = "", className = "", video = false, controls = false, muted = true, ...props }) => {
  const { url } = useAuthenticatedMedia(src);
  if (!url) return <span className={`${className} authenticated-media-loading`} aria-label="Loading media" />;
  return video
    ? <video src={url} className={className} controls={controls} muted={muted} playsInline {...props} />
    : <img src={url} className={className} alt={alt} {...props} />;
};

export { useAuthenticatedMedia };
export default AuthenticatedMedia;
